module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Box1-7a15484ade5202afd0213367e4535ffa.svg";